import { resolvePath, useLocation } from 'react-router-dom';

import { Navigate } from '../Navigate';

export const NotFound = () => {
  const location = useLocation();

  return (
    <Navigate
      to={resolvePath('..', location.pathname).pathname}
      keepSearchParams
      replace
    />
  );
};
